var _defs, _rect, _text, _text2, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDecision(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 320,
    viewBox: "0 0 560 320",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0A0B0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0B0D12"
  })), /*#__PURE__*/React.createElement("style", null, "\n      :root{\n        --ink:#EAF2FF; --muted:#9AA4B2; --stroke:#1E2330;\n        --candle-blue:#4DA3FF;  /* set to your live candle blue */\n        --candle-red:#FF5A5A;   /* set to your live candle red  */\n        --green:#10B981; --red:#EF4444;\n      }\n      text{font-family:Inter,system-ui}\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 320,
    fill: "url(#bg2)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 40,
    fill: "var(--ink)",
    fontSize: 18,
    fontWeight: 700
  }, "Decision Engine")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 58,
    fill: "var(--muted)",
    fontSize: 12
  }, "timeline signals and actions")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24,80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 164,
    fill: "#101217",
    stroke: "var(--stroke)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 110,
    width: 8,
    height: 24,
    fill: "var(--candle-blue)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 98,
    width: 8,
    height: 36,
    fill: "var(--candle-blue)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 120,
    width: 8,
    height: 18,
    fill: "var(--candle-red)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 90,
    width: 8,
    height: 46,
    fill: "var(--candle-blue)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 78,
    width: 8,
    height: 58,
    fill: "var(--candle-blue)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 94,
    width: 8,
    height: 42,
    fill: "var(--candle-red)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 72,
    width: 8,
    height: 64,
    fill: "var(--candle-blue)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 82,
    width: 8,
    height: 54,
    fill: "var(--candle-blue)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 96,
    width: 8,
    height: 40,
    fill: "var(--candle-red)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 86,
    width: 8,
    height: 50,
    fill: "var(--candle-blue)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 100,
    width: 8,
    height: 36,
    fill: "var(--candle-red)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 92,
    width: 8,
    height: 44,
    fill: "var(--candle-blue)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 106,
    width: 8,
    height: 30,
    fill: "var(--candle-red)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 114,
    width: 8,
    height: 22,
    fill: "var(--candle-red)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 94,
    width: 8,
    height: 42,
    fill: "var(--candle-blue)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 84,
    width: 8,
    height: 52,
    fill: "var(--candle-blue)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 102,
    width: 8,
    height: 34,
    fill: "var(--candle-red)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 88,
    width: 8,
    height: 48,
    fill: "var(--candle-blue)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 110,
    width: 8,
    height: 24,
    fill: "var(--candle-red)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 156,
    x2: 512,
    y2: 156,
    stroke: "#232833",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 156,
    x2: 170,
    y2: 40,
    stroke: "var(--green)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 14,
    rx: 6,
    ry: 6,
    width: 68,
    height: 22,
    fill: "#0F8F6E"
  }), /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 29,
    textAnchor: "middle",
    fill: "#EAF2FF",
    fontSize: 11,
    fontWeight: 800
  }, "PROCEED"), /*#__PURE__*/React.createElement("line", {
    x1: 408,
    y1: 156,
    x2: 408,
    y2: 70,
    stroke: "var(--red)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 46,
    rx: 6,
    ry: 6,
    width: 48,
    height: 22,
    fill: "#B91C1C"
  }), /*#__PURE__*/React.createElement("text", {
    x: 408,
    y: 61,
    textAnchor: "middle",
    fill: "#FDECEC",
    fontSize: 11,
    fontWeight: 800
  }, "EXIT"), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 156,
    r: 6,
    fill: "#9AA4B2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 182,
    fill: "#9AA4B2",
    textAnchor: "middle",
    fontSize: 10
  }, "skip")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24,264)",
    fontSize: 11
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 10,
    height: 10,
    fill: "var(--candle-blue)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 9,
    fill: "var(--muted)"
  }, "up candle"), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 0,
    width: 10,
    height: 10,
    fill: "var(--candle-red)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 9,
    fill: "var(--muted)"
  }, "down candle"), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 0,
    width: 10,
    height: 10,
    fill: "var(--green)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 212,
    y: 9,
    fill: "var(--muted)"
  }, "proceed"), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 0,
    width: 10,
    height: 10,
    fill: "var(--red)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 298,
    y: 9,
    fill: "var(--muted)"
  }, "exit"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecision);
export default __webpack_public_path__ + "static/media/decision.41f0cab7884dd144d1b7ce055b26fca1.svg";
export { ForwardRef as ReactComponent };